<template>
  <div>
    <div class="maintitle">模板列表</div>
    <el-divider></el-divider>
    <el-row class="text-left" :gutter="10">
      <el-col :span='6'>
        <el-input v-model='keyword' placeholder="请输入搜索关键词" size="mini" @keyup.enter.native="searchList"></el-input>
      </el-col>
      <!-- <el-cascader clearable size='mini' v-model="crntdepartment" :props="{ checkStrictly: true }" :show-all-levels="false" :options="departmentlist"></el-cascader> -->
      <el-select v-model="crnttype" placeholder="请选择模板类型" size="mini" class="margin-left" @change="resetList">
        <el-option label='员工考核模板' :value='1'></el-option>
        <el-option label='部门考核模板' :value='2'></el-option>
      </el-select>
      <el-button type="success" size="mini" @click="searchList" class="margin-left">筛选</el-button>
      <el-button type="success" size="mini" @click="addDiv = true" class="margin-left">添加新模板</el-button>
    </el-row>
    <el-table :data="list" row-key="id" border>
      <el-table-column prop="name" label="模板名称"></el-table-column>
      <el-table-column prop="department_name" label="部门名称"></el-table-column>
      <el-table-column label="状态" :formatter="formatstatus"></el-table-column>
      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="scope">
          <el-button type='text' @click="mdfy(scope)" size='mini'>修改</el-button>
          <el-button type='text' class="margin-small-left" @click="setStatus(scope)" size='mini'>{{scope.row.status == 1 ? "停用" : "启用"}}</el-button>
          <el-button type='text' class="margin-small-left" @click="del(scope)" size='mini'>删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background :current-page="page" :page-sizes="pagesizes" :page-size="pagesize" @size-change="handleSizeChange" @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    <el-dialog :visible.sync="addDiv" :show-close="false" :close-on-click-modal="false" @open="initinfo" @close="resetinfo" width="100%">
      <el-row :gutter="10">
        <el-col :span='2' class="text-right item-title">模板名称</el-col>
        <el-col :span='4'>
          <el-input v-model="templateinfo.name" auto-complete="off" size='mini' placeholder="请输入模板名称"></el-input>
        </el-col>
        <el-col :span='2' class="text-right item-title">归属部门</el-col>
        <el-col :span='6' class="text-left">
          <div class="block" placeholder='请选择归属部门'>
            <el-cascader size='mini' v-model="templateinfo.did" :props="{ checkStrictly: true }" :show-all-levels="false" :options="departmentlist"></el-cascader>
          </div>
        </el-col>
        <el-col :span='2' class="text-right item-title">模板类型</el-col>
        <el-col :span='8'>
          <el-select v-model="templateinfo.type" placeholder="请选择模板类型" size="mini">
            <el-option label='员工考核模板' :value='1'></el-option>
            <el-option label='部门考核模板' :value='2'></el-option>
          </el-select>
        </el-col>
      </el-row>
      <div>
        <h2>考核标准</h2>
      </div>
      <div class="itemgroup" v-for="(item , index) in templateinfo.items" :key='index'>
        <el-row :gutter="10">
          <el-col :span='2' class="text-right item-title">工作项</el-col>
          <el-col :span='4'>
            <el-input v-model="templateinfo.items[index].title" placeholder="请输入工作项" size='mini'></el-input>
          </el-col>
          <el-col :span='2' class="text-right item-title">达标标准</el-col>
          <el-col :span='16' class="text-left">
            <el-input type="textarea" autosize v-model="templateinfo.items[index].standard" placeholder="请输入达标标准"></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span='2' class="text-right item-title">权重占比</el-col>
          <el-col :span='4'>
            <el-input v-model="templateinfo.items[index].proportion" type='number' placeholder="请输入权重占比" size='mini'></el-input>
          </el-col>
          <el-col :span='2' class="text-right item-title">评分标准</el-col>
          <el-col :span='16' class="text-left">
            <el-input type="textarea" autosize v-model="templateinfo.items[index].points" placeholder="请输入评分标准"></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span='2' class="text-right item-title">具体要求</el-col>
          <el-col :span='22'>
            <el-input type="textarea" autosize v-model="templateinfo.items[index].request" placeholder="请输入具体要求"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-button @click="deleteItem(index)" v-if="templateinfo.items.length>1">删除</el-button>
          <el-button @click="movePre(index)" v-if='index>0'>上移</el-button>
          <el-button @click="moveNext(index)" v-if='index<(templateinfo.items.length-1)'>下移</el-button>
        </el-row>
      </div>
      <el-button type='primary' @click="additem" size='mini'>添加考核内容</el-button>
      <div class="padding-big-top">
        <h2>优秀标准</h2>
      </div>
      <div class="itemgroup" v-for="(item , index) in templateinfo.excellents" :key='index'>
        <el-row :gutter="10">
          <el-col :span='2' class="text-right item-title">优秀标准</el-col>
          <el-col :span='14' class="text-left">
            <el-input type="textarea" autosize v-model="templateinfo.excellents[index].standard" placeholder="请输入优秀标准"></el-input>
          </el-col>
          <el-col :span='8'>
            <el-button type='text' @click="deleteItem(index,'excellents')" v-if="templateinfo.excellents.length>1">删除</el-button>
            <el-button type='text' @click="movePre(index,'excellents')" v-if='index>0'>上移</el-button>
            <el-button type='text' @click="moveNext(index,'excellents')" v-if='index<(templateinfo.excellents.length-1)'>下移</el-button>
          </el-col>
        </el-row>
      </div>
      <el-button type='primary' @click="addExcellent" size='mini'>添加优秀标准</el-button>
      <div slot="footer" class="dialog-footer">
        <el-button type='danger' @click="addDiv = false;">取 消</el-button>
        <el-button type="success" @click="submdfy">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [], //模板列表
      crnttype: 1,
      addDiv: false,
      page: 1,
      total: 0,
      templateinfo: {
        id: 0,
        name: "",
        did: "",
        type: 1,
        items: [
          {
            id: 0,
            title: '',
            standard: '',
            points: '',
            proportion: '',
            request: '',
            type: 1
          }
        ],
        excellents: [
          {
            id: 0,
            standard: '',
            type: 2
          }
        ]
      },
      keyword: '',
      formLabelWidth: '80px',
      departmentlist: [],
      crntdepartment: '',
      tempinfo:{}
    };
  },
  methods: {
    searchList() {
      this.page = 1;
      this.getlist();
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.page = 1;
      this.getlist();
    },
    handleCurrentChange(p) {
      this.page = p;
      this.getlist();
    },
    deleteItem(index, str) {
      str = str ? str : 'items';
      this.templateinfo[str].splice(index, 1);
    },
    additem() {
      this.templateinfo.items.push({
        id: 0,
        title: '',
        standard: '',
        points: '',
        proportion: '',
        request: '',
        type: 1
      })
    },
    addExcellent() {
      this.templateinfo.excellents.push({
        id: 0,
        standard: '',
        type: 2
      })
    },
    getlist() {
      this.$axios({
        url: this.HOST + "/kaohe/template/getTemplateList",
        method: "post",
        data: {
          type: this.crnttype,
          keyword: this.keyword,
          page: this.page,
          pagesize: this.pagesize
        },
      }).then((res) => {
        if (res.data.status == 1) {
          this.list = res.data.list.data;
          this.total = res.data.list.total;
          this.grouplist = res.data.grouplist;
        }
      });
    },
    showchildren(scope) {
      this.childlist = scope.row.children;
      this.showchildrendiv = true;
    },
    formatstatus(row, column) {
      return row.status == 1 ? "正常" : "停用";
    },
    formathidden(row, column) {
      return row.isshow == 1 ? "正常" : "隐藏";
    },
    setStatus(scope) {
      let status = scope.row.status == 1 ? 0 : 1;
      this.$axios({
        url: this.HOST + "/kaohe/template/setStatus",
        method: "post",
        data: {
          info: {
            id: scope.row.id,
            status: status,
          },
        },
      }).then((res) => {
        if (res.data.status == 1) {
          scope.row.status = status;
        }
      });
    },
    //重置模板编辑对话框内容
    resetFormInfo() {
      this.$refs["templateinfo"].resetFields();
      this.crntscope = "";
      this.crntpid = "";
    },
    mdfy(scope) {
      this.crntscope = scope;
      this.addDiv = true;
    },
    movePre(index, str) {
      if (index == 0) {
        return;
      }
      str = str ? str : 'items';
      let templist = this.templateinfo[str];
      let temp = templist.splice(index, 1);
      templist.splice(index - 1, 0, temp[0]);
    },
    moveNext(index, str) {
      str = str ? str : 'items';
      //元素下移
      let templist = this.templateinfo[str];
      if (index == (templist.length - 1)) {
        return;
      }
      let temp = templist.splice(index, 1);
      templist.splice(index + 1, 0, temp[0]);
    },
    initinfo() {
      if (this.crntscope != "") {
        this.$axios({
          url: this.HOST + '/kaohe/template/getTemplateInfo',
          method: 'post',
          data: {
            id: this.crntscope.row.id
          }
        }).then(res => {
          this.templateinfo = res.data.data;
        });
      }
    },
    resetinfo() {
      for(let i in this.templateinfo){
        this.templateinfo[i] = this.tempinfo[i];
      }
      this.crntscope = '';
    },
    addchild(scope) {
      this.crntpid = scope.row.menuid;
      this.addDiv = true;
    },
    submdfy() {
      this.$axios({
        url: this.HOST + "/kaohe/template/addTemplate",
        method: "post",
        data: {
          info: this.templateinfo,
        },
      }).then((res) => {
        if (res.data.status == 1) {
          this.addDiv = false;
          this.getlist();
        }
      });
    },
    del(scope) {
      this.$confirm(
        '确定要修改模板"' +
        scope.row.name +
        '"吗？本操作会同步操作子模板并且不可恢复！！！',
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.$axios({
          url: this.HOST + "/kaohe/template/del",
          method: "post",
          data: {
            id: scope.row.id,
          },
        }).then((res) => {
          if (res.data.status == 1) {
            this.getlist();
            this.$message({
              type: "info",
              message: "操作成功",
            });
          }
        });
      });
    },
    getCommonInfo() {
      this.$axios({
        url: this.HOST + '/kaohe/index/getCommonInfo',
        method: 'post',
        data: {
          info: ['department']
        }
      }).then(res => {
        this.departmentlist = res.data.departmentlist;
      })
    },
    resetList() {
      this.list = [];
      this.page = 1;
      this.total = 0;
    }
  },
  created: function () {
    this.getCommonInfo();
    this.getlist();
    for(let i in this.templateinfo){
      this.tempinfo[i] = this.templateinfo[i];
    }
  },
};
</script>
<style scoped>
.itemgroup {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 20px 20px 0 0;
  margin-bottom: 10px;
  width: 100%;
  box-sizing: border-box;
}
.itemgroup * {
  box-sizing: border-box;
}
.item-title {
  line-height: 28px;
}
</style>